import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const WorkflowPage = lazy(() => import('./WorkflowPage'));
const PERMS = ['workflow.read', 'workflow.configure', 'workflow.approve'];

const routes: RouteObject[] = [
  { path: '/workflow', element: <Guard any={PERMS}><WorkflowPage /></Guard> },
  // approval links for limit changes (LIM-...) arrive as /workflow/<change number>
  { path: '/workflow/:ref', element: <Guard any={PERMS}><WorkflowPage /></Guard> },
];
export default routes;
